if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    // ✅ Récupère la quantité choisie manuellement par l'utilisateur (+/-)
    getUserQuantity() {
      const quantityInput =
        this.form.querySelector('[name="quantity"]') ||
        (this.closest('.product') && this.closest('.product').querySelector('[name="quantity"]')) ||
        document.querySelector('.product__quantity [name="quantity"]') ||
        document.querySelector('quantity-input input') ||
        document.querySelector('.quantity__input');

      return quantityInput ? (parseInt(quantityInput.value) || 1) : 1;
    }

    // ✅ Récupère la quantité du bundle Easy Bundle sélectionné
    getBundleQuantity() {
      // Easy Bundle : le bundle actif a la classe "bundle selected"
      const selectedBundle = document.querySelector('#easy-bundle .bundle.selected');

      if (selectedBundle) {
        // Cherche d'abord dans les data attributes
        const dataQty =
          parseInt(selectedBundle.dataset.quantity) ||
          parseInt(selectedBundle.dataset.qty) ||
          parseInt(selectedBundle.dataset.bundleQuantity) ||
          null;

        if (dataQty && dataQty > 0) return dataQty;

        // Sinon, extrait le nombre depuis le texte "2 produits", "3 produits"...
        const titleEl = selectedBundle.querySelector('.bundle-title .name-container, .bundle-title, .bundle-name');
        const text = titleEl ? titleEl.textContent : selectedBundle.textContent;
        const match = text.match(/(\d+)\s*(produit|article|item|pièce)/i);
        if (match) return parseInt(match[1]);
      }

      return 1; // Par défaut : 1 si aucun bundle actif détecté
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // ✅ FIX QUANTITÉ — quantité finale = sélecteur (+/-) × bundle sélectionné
      // Exemples :
      //   sélecteur=4, bundle="1 produit" → 4 × 1 = 4 ajoutés
      //   sélecteur=4, bundle="2 produits" → 4 × 2 = 8 ajoutés (remise sur chaque 2ème)
      //   sélecteur=3, bundle="2 produits" → 3 × 2 = 6 ajoutés
      const userQty   = this.getUserQuantity();
      const bundleQty = this.getBundleQuantity();
      const finalQty  = userQty * bundleQty;

      formData.set('quantity', finalQty);

      // Debug console — à retirer une fois validé
      console.log(`[ProductForm] userQty=${userQty} × bundleQty=${bundleQty} = finalQty=${finalQty}`);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
            });
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    document.querySelector('footer').classList.add('sticky-cart-modal_bottom_padding');
  }

  update() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;

    if (window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')) {
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if (window.scrollY < rangeToShowModal && this.classList.contains('show-modal')) {
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }

  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}

customElements.define('sticky-cart-modal', stickyCartModal);
